import {useRef} from 'react';
import {Link} from 'react-router-dom';
import {motion,useScroll,useTransform} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import SplitText from './SplitText';
import Magnetic from './Magnetic';

const {FiArrowUpRight}=FiIcons;

function HomeHero() {
  const ref=useRef(null);
  const {scrollYProgress}=useScroll({target: ref,offset: ['start start','end start']});
  const imgY=useTransform(scrollYProgress,[0,1],['0%','22%']);
  const textY=useTransform(scrollYProgress,[0,1],['0%','-18%']);
  const fade=useTransform(scrollYProgress,[0,0.7],[1,0]);

  return (
    <section ref={ref} className="relative isolate flex min-h-[calc(100svh-78px)] items-end overflow-hidden bg-ink text-white">
      <motion.img
        src="https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?auto=format&amp;fit=crop&amp;w=2400&amp;q=90"
        alt="Elegant home with a paver driveway approach"
        className="absolute inset-0 -z-20 h-[125%] w-full object-cover"
        style={{y: imgY}}
        initial={{scale: 1.15}}
        animate={{scale: 1}}
        transition={{duration: 2.6,ease: 'easeOut'}}
      />
      <div className="absolute inset-0 -z-10 bg-gradient-to-r from-ink/90 via-ink/55 to-ink/10" />
      <div className="absolute inset-0 -z-10 bg-gradient-to-t from-ink/85 via-transparent to-transparent" />
      <motion.div className="wrap pb-20 pt-32 md:pb-28" style={{y: textY,opacity: fade}}>
        <motion.p
          className="eyebrow flex items-center gap-4 !text-clay"
          initial={{opacity: 0,x: -20}}
          animate={{opacity: 1,x: 0}}
          transition={{delay: 0.2}}
        >
          <span className="h-px w-12 bg-clay" />
          Premium paver installation
        </motion.p>
        <h1 className="h-display mt-6 max-w-[1200px] text-[clamp(2.7rem,6.5vw,6.5rem)] leading-[1.08]">
          <SplitText text="Paver installation." accent="30+ years of getting it right." delay={0.35} />
        </h1>
        <motion.p
          className="mt-8 max-w-lg text-base leading-8 text-white/80"
          initial={{opacity: 0,y: 20}}
          animate={{opacity: 1,y: 0}}
          transition={{delay: 1.2,duration: 0.8}}
        >
          Transform your driveway, patio, pool deck or walkway with expertly installed pavers, backed by over 30 years of craftsmanship.
        </motion.p>
        <motion.div
          className="mt-10 flex flex-col gap-4 sm:flex-row sm:items-center"
          initial={{opacity: 0,y: 20}}
          animate={{opacity: 1,y: 0}}
          transition={{delay: 1.4,duration: 0.8}}
        >
          <Magnetic>
            <Link to="/contact" className="btn btn-brick">
              Request a Quote <SafeIcon icon={FiArrowUpRight} className="text-base" />
            </Link>
          </Magnetic>
          <Magnetic>
            <Link to="/materials" className="btn btn-ghost">Explore Paver Styles</Link>
          </Magnetic>
        </motion.div>
      </motion.div>
      <motion.div
        className="absolute bottom-8 right-8 hidden items-center gap-3 text-[10px] font-bold uppercase tracking-[0.22em] text-white/70 md:flex"
        style={{opacity: fade}}
      >
        Scroll
        <span className="relative h-14 w-px overflow-hidden bg-white/25">
          <motion.span className="absolute inset-x-0 top-0 h-5 bg-clay" animate={{y: [-20,56]}} transition={{duration: 1.6,repeat: Infinity,ease: 'easeInOut'}} />
        </span>
      </motion.div>
    </section>
  );
}

export default HomeHero;
